import React from "react";

// import Play from "./Play";
function CustomControls(props) {
  return <></>;
}
export default CustomControls;
